import { gql } from '@apollo/client'

const PRIORITY_TASK_PROGRESS_COUNTS_QUERY = gql`
  query priorityTaskProgressCountsQuery {
    priorityTaskProgressCounts {
      allocatedDishCount
      doneCount
    }
  }
`

export default PRIORITY_TASK_PROGRESS_COUNTS_QUERY
